import { useState, useEffect } from "react";
import api from "./api";

export const IMG = {
  hero: "https://images.unsplash.com/photo-1631510390389-c1e4fb20ff31?crop=entropy&cs=srgb&fm=jpg&q=80&w=1300",
  apartment: "https://images.unsplash.com/photo-1665249934445-1de680641f50?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100",
  acWall: "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100",
  checklist: "https://images.unsplash.com/photo-1523705480679-b5d0cc17a656?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100",
  tools: "https://images.unsplash.com/photo-1567361809214-b97d828071d9?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100",
  rome: "https://images.unsplash.com/photo-1778102730337-edef43a47916?crop=entropy&cs=srgb&fm=jpg&q=80&w=1300",
  filter: "https://images.unsplash.com/photo-1737012197886-7d5a52ded45b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100",
};

export const COLORS = { navy: "#0B1F3A", petrol: "#0E7C7B", orange: "#F97316", mist: "#F4F7FB" };

export const PLAN_OPTIONS = [
  { v: "basic", l: "Basic" },
  { v: "pro", l: "Pro" },
  { v: "premium", l: "Premium" },
  { v: "aiuto", l: "Aiutatemi a scegliere" },
];

export const ROLE_OPTIONS = ["Host", "Property manager", "Proprietario", "Struttura ricettiva", "Altro"];

export const LEAD_STATUS = {
  nuovo: { label: "Nuovo", cls: "bg-blue-100 text-blue-700 border-blue-200" },
  da_contattare: { label: "Da contattare", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  contattato: { label: "Contattato", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  analisi_fissata: { label: "Analisi fissata", cls: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  proposta_inviata: { label: "Proposta inviata", cls: "bg-violet-100 text-violet-700 border-violet-200" },
  negoziazione: { label: "Negoziazione", cls: "bg-orange-100 text-orange-700 border-orange-200" },
  firmato: { label: "Firmato", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  attivo: { label: "Attivo", cls: "bg-emerald-200 text-emerald-900 border-emerald-300" },
  perso: { label: "Perso", cls: "bg-rose-100 text-rose-700 border-rose-200" },
  non_qualificato: { label: "Non qualificato", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  ricontattare: { label: "Ricontattare più avanti", cls: "bg-yellow-100 text-yellow-700 border-yellow-200" },
};

export const LEAD_STATUS_ORDER = Object.keys(LEAD_STATUS);

let _cache = null;
export function fetchB2BSettings() {
  if (!_cache) _cache = api.get("/b2b/settings").then((r) => r.data);
  return _cache;
}
export function useB2BSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { fetchB2BSettings().then(setS).catch(() => setS(null)); }, []);
  return s;
}
